import KvkkModal from '../components/KvkkModal';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import { ShieldCheck, Bell, Search, ChevronDown, BookOpen, LogOut, Trophy, CheckCircle, Clock, Award, Play, Plus, X, AlertCircle, Newspaper, Menu, LayoutDashboard, GraduationCap } from 'lucide-react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

const CourseCard = ({ course, onClick }) => {
  const isMobile = useIsMobile();
  
  // YENİ KURAL: Gerçek tamamlanma durumunu backend'den gelen "completed_at" belirler
  
  const isCompleted = course.has_quiz ? course.quiz_passed : (!!course.completed_at || (course.total_videos > 0 && course.completed_videos >= course.total_videos));
  
  let progress = course.total_videos > 0 ? Math.round((course.completed_videos / course.total_videos) * 100) : 0;
  
  // Videolar bittiği halde sınav geçilmemişse %99'da tut
  if (progress === 100 && !isCompleted) {
    progress = 99;
  }
  if (isCompleted) {
    progress = 100;
  }

  const isOverdue = course.due_date && new Date(course.due_date) < new Date() && !isCompleted;
  
  return (
    <div className="course-card-premium" onClick={onClick} style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(20px)', borderRadius: 16, overflow: 'hidden', cursor: 'pointer', border: '1px solid rgba(255,255,255,0.9)' }}>
      <div style={{ height: 110, background: course.thumbnail ? 'transparent' : 'linear-gradient(135deg, #1a1a2e, #E30613)', position: 'relative', overflow: 'hidden' }}>
        {course.thumbnail
          ? <img src={'/uploads/thumbnails/' + course.thumbnail + '?v=2'} alt={course.title} className="course-thumb-premium" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><BookOpen size={36} color="rgba(255,255,255,0.4)" strokeWidth={1} /></div>}
        {course.is_mandatory && <div style={{ position: 'absolute', top: 8, left: 8, background: '#ff3b30', color: 'white', borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>ZORUNLU</div>}
        {isCompleted && <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(52,199,89,0.9)', borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CheckCircle size={14} color="white" /></div>}
        {isOverdue && <div style={{ position: 'absolute', bottom: 8, right: 8, background: 'rgba(255,59,48,0.9)', color: 'white', borderRadius: 6, padding: '2px 8px', fontSize: 10, fontWeight: 700 }}>GECİKMİŞ</div>}
      </div>
      <div style={{ padding: '12px 14px' }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a2e', marginBottom: 8, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{course.title}</div>
        <div style={{ height: 4, background: 'rgba(0,0,0,0.06)', borderRadius: 4, marginBottom: 8, overflow: 'hidden' }}>
          <div style={{ height: '100%', width: progress + '%', background: isCompleted ? '#34c759' : (progress === 99 ? '#f59e0b' : 'linear-gradient(90deg, #E30613, #8b0000)'), borderRadius: 4, transition: 'width 0.5s' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 11, color: '#9ca3af' }}>
          <span>{progress}% tamamlandı {progress === 99 && !isCompleted ? <span style={{color: '#f59e0b', fontWeight: 600}}>(Sınav Bekliyor)</span> : ''}</span>
          <span>{course.completed_videos}/{course.total_videos} video</span>
        </div>
        {course.avg_rating > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 6 }}>
            <span style={{ color: '#f59e0b', fontSize: 12 }}>{'★'.repeat(Math.round(course.avg_rating))}{'☆'.repeat(5-Math.round(course.avg_rating))}</span>
            <span style={{ fontSize: 10, color: '#9ca3af' }}>{parseFloat(course.avg_rating).toFixed(1)} ({course.rating_count})</span>
          </div>
        )}
      </div>
    </div>
  );
};

const Navbar = ({ user, onLogout, onSearch, searchVal, notifications, onMenuToggle, onPasswordChange, onRefresh, refreshing }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [notifOpen, setNotifOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const unread = notifications.filter(n => n.total_videos > n.completed_videos).length;
  return (
    <nav style={{ background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0,0,0,0.07)', padding: isMobile ? '0 14px' : '0 32px', height: 62, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 200, gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
        <button onClick={onMenuToggle} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>
          <Menu size={22} color="#374151" />
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => navigate('/panel')}>
          <div style={{ height: 36, background: 'linear-gradient(135deg, #1a0000, #E30613)', borderRadius: 10, padding: '4px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/uploads/assets/logo.png" alt="Petlas" style={{ height: 24, objectFit: 'contain', filter: 'brightness(0) invert(1)' }}
              onError={e => { e.target.style.display='none'; }} />
          </div>
          {!isMobile && (
            <div>
              <div style={{ fontWeight: 800, fontSize: 13, color: '#1a1a2e', lineHeight: 1.2 }}>Eğitim ve Akademi</div>
              <div style={{ fontSize: 10, color: '#9ca3af', fontWeight: 500, letterSpacing: 0.5 }}>Portalı</div>
            </div>
          )}
        </div>
      </div>
      <div style={{ flex: 1, maxWidth: 360, display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(0,0,0,0.05)', borderRadius: 12, padding: '8px 14px' }}>
        <Search size={15} color="#9ca3af" />
        <input placeholder="Eğitim ara..." value={searchVal} onChange={e => onSearch(e.target.value)}
          style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: 13, width: '100%', color: '#374151' }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {onRefresh && (
          <button onClick={onRefresh} disabled={refreshing}
            style={{ background: 'rgba(0,0,0,0.05)', border: 'none', borderRadius: 10, width: 38, height: 38, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, transform: refreshing ? 'rotate(360deg)' : 'none', transition: refreshing ? 'transform 1s linear' : 'none' }}>
            ⟳
          </button>
        )}
        <div style={{ position: 'relative' }}>
          <button onClick={() => { setNotifOpen(!notifOpen); setUserMenuOpen(false); }}
            style={{ background: 'rgba(0,0,0,0.05)', border: 'none', borderRadius: 10, width: 38, height: 38, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <Bell size={17} color="#374151" />
            {unread > 0 && <div style={{ position: 'absolute', top: 6, right: 6, width: 8, height: 8, background: '#ff3b30', borderRadius: '50%' }} />}
          </button>
          {notifOpen && (
            <div style={{ position: 'absolute', top: 48, right: 0, background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.15)', width: 340, zIndex: 300, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.08)' }}>
              <div style={{ padding: '16px 18px', borderBottom: '1px solid rgba(0,0,0,0.06)', fontWeight: 700, fontSize: 14 }}>Bildirimler</div>
              <div style={{ maxHeight: 300, overflow: 'auto' }}>
                {notifications.length === 0 ? <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Bildirim yok</div>
                  : notifications.slice(0, 10).map((n, i) => (
                    <div key={i} onClick={() => { navigate('/egitim/' + n.course_id); setNotifOpen(false); }} style={{ padding: '12px 18px', borderBottom: '1px solid rgba(0,0,0,0.04)', cursor: 'pointer', background: 'transparent' }} onMouseEnter={e => e.currentTarget.style.background='rgba(0,0,0,0.03)'} onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                      <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>
                        {n.is_mandatory && <span style={{ color: '#ff3b30', fontWeight: 700, marginRight: 4 }}>ZORUNLU</span>}
                        {n.title}
                      </div>
                      {n.due_date && <div style={{ fontSize: 11, color: new Date(n.due_date) < new Date() ? '#ff3b30' : '#9ca3af', marginTop: 4 }}>Son: {new Date(n.due_date).toLocaleDateString('tr-TR')}</div>}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <div style={{ position: 'relative' }}>
          <button onClick={() => { setUserMenuOpen(!userMenuOpen); setNotifOpen(false); }}
            style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(0,0,0,0.05)', border: 'none', borderRadius: 10, padding: '6px 12px 6px 6px', cursor: 'pointer' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'linear-gradient(135deg, #E30613, #8b0000)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: 12 }}>{user?.name?.charAt(0).toUpperCase()}</div>
            {!isMobile && <span style={{ fontWeight: 600, fontSize: 13, color: '#374151' }}>{user?.name?.split(' ')[0]}</span>}
            <ChevronDown size={13} color="#9ca3af" />
          </button>
          {userMenuOpen && (
            <div style={{ position: 'absolute', top: 50, right: 0, background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', borderRadius: 16, boxShadow: '0 20px 60px rgba(0,0,0,0.15)', width: 220, zIndex: 300, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.08)' }}>
              <div style={{ padding: '14px 16px', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a2e' }}>{user?.name}</div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{user?.company || 'Petlas'}</div>
              </div>
              <div onClick={() => { onPasswordChange(); setUserMenuOpen(false); }}
                style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, color: '#374151', borderBottom: '1px solid rgba(0,0,0,0.04)' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(227,6,19,0.05)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                Profil Ayarları
              </div>
              {[{ icon: Award, label: 'Sertifikalarım', path: '/sertifikalar' }, { icon: Newspaper, label: 'Eğitim & Faaliyetler', path: '/faaliyetler' }].map(item => (
                <div key={item.path} onClick={() => { navigate(item.path); setUserMenuOpen(false); }}
                  style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, color: '#374151' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(227,6,19,0.05)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <item.icon size={14} strokeWidth={1.8} /> {item.label}
                </div>
              ))}
              <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                <div onClick={onLogout} style={{ padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13, color: '#ff3b30' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,59,48,0.05)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <LogOut size={14} strokeWidth={1.8} /> Çıkış Yap
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default function Dashboard() {
  const { user, logout, setUser } = useAuth();
  const [showKvkkWelcome, setShowKvkkWelcome] = useState(false);
  const [showKvkkRead, setShowKvkkRead] = useState(false);

  useEffect(() => {
    if (!user) return;
    const localConfirmed = localStorage.getItem('kvkk_confirmed_' + user.id);
    if (user.kvkk_accepted_at || localConfirmed) {
      setShowKvkkWelcome(false);
    } else {
      setShowKvkkWelcome(true);
    }
  }, [user]);

  const handleKvkkConfirm = async () => {
    try {
      setShowKvkkWelcome(false);
      if (user?.id) {
        localStorage.setItem('kvkk_confirmed_' + user.id, 'true');
      }
      await api.post('/users/kvkk-confirm');
      if (setUser) {
        setUser(prev => ({ ...prev, kvkk_accepted_at: new Date().toISOString() }));
      }
    } catch (err) {
      console.error('KVKK onay hatası:', err);
      setShowKvkkWelcome(false);
    }
  };
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [myCourses, setMyCourses] = useState([]);
  const [catalog, setCatalog] = useState([]);
  const [filteredCatalog, setFilteredCatalog] = useState([]);
  const [tab, setTab] = useState('my');
  const [notifications, setNotifications] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [pullStart, setPullStart] = useState(0);
  const [pullDistance, setPullDistance] = useState(0);

  const refreshData = async () => {
    setRefreshing(true);
    await Promise.all([
      api.get('/users/me/courses').then(r => setMyCourses(r.data)),
      api.get('/courses').then(r => { setCatalog(r.data); setFilteredCatalog(r.data); }),
    ]);
    setRefreshing(false);
  };

  useEffect(() => {
    if (!isMobile) return;
    const onTouchStart = (e) => setPullStart(e.touches[0].clientY);
    const onTouchMove = (e) => {
      const dist = e.touches[0].clientY - pullStart;
      if (dist > 0 && window.scrollY === 0) setPullDistance(Math.min(dist, 80));
    };
    const onTouchEnd = () => {
      if (pullDistance > 60) refreshData();
      setPullDistance(0);
      setPullStart(0);
    };
    window.addEventListener('touchstart', onTouchStart);
    window.addEventListener('touchmove', onTouchMove);
    window.addEventListener('touchend', onTouchEnd);
    return () => {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };
  }, [isMobile, pullStart, pullDistance]);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ current: '', newPass: '', confirm: '' });
  const [profileForm, setProfileForm] = useState({ email: '', phone: '' });
  const [profileMsg, setProfileMsg] = useState('');
  const [profileError, setProfileError] = useState('');
  const [savingProfile, setSavingProfile] = useState(false);
  const [profileTab, setProfileTab] = useState('profile');
  const [passwordMsg, setPasswordMsg] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.history.pushState(null, document.title, window.location.href);
    const onPop = () => {
      window.history.pushState(null, document.title, window.location.href);
      setShowLogoutConfirm(true);
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    api.get('/users/me/courses').then(r => setMyCourses(r.data));
    api.get('/courses').then(r => { setCatalog(r.data); setFilteredCatalog(r.data); });
    api.get('/users/me/notifications').then(r => setNotifications(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!searchVal) { setFilteredCatalog(catalog); return; }
    setFilteredCatalog(catalog.filter(c => c.title.toLowerCase().includes(searchVal.toLowerCase())));
  }, [searchVal, catalog]);

  const handleLogout = () => setShowLogoutConfirm(true);

  function openPasswordModal() {
    setProfileForm({ email: user?.email || '', phone: user?.phone || '' });
    setProfileMsg(''); setProfileError('');
    setPasswordMsg(''); setPasswordError('');
    setProfileTab('profile');
    setShowPasswordModal(true);
  };

  const saveProfile = async () => {
    setProfileError('');
    setProfileMsg('');
    setSavingProfile(true);

    try {
      const response = await api.put('/users/me/profile', {
        email: profileForm.email.trim(),
        phone: profileForm.phone.trim()
      });

      const updatedUser = {
        ...user,
        ...response.data,
        email: response.data.email || '',
        phone: response.data.phone || ''
      };

      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));

      setProfileForm({
        email: updatedUser.email,
        phone: updatedUser.phone
      });

      setProfileMsg('Profil bilgileriniz başarıyla güncellendi!');
      setTimeout(() => setProfileMsg(''), 3000);

    } catch(e) {
      setProfileError(
        e.response?.data?.error || 'Profil bilgileriniz güncellenirken bir hata oluştu.'
      );
    } finally {
      setSavingProfile(false);
    }
  };

  const changePassword = async () => {
    setPasswordError(''); setPasswordMsg('');
    if (!passwordForm.current || !passwordForm.newPass) { setPasswordError('Tüm alanlar zorunlu'); return; }
    if (passwordForm.newPass !== passwordForm.confirm) { setPasswordError('Yeni şifreler eşleşmiyor'); return; }
    if (passwordForm.newPass.length < 6) { setPasswordError('Şifre en az 6 karakter olmalı'); return; }
    setSavingPassword(true);
    try {
      await api.post('/users/' + user.id + '/change-password', { password: passwordForm.newPass, currentPassword: passwordForm.current });
      setPasswordMsg('Şifreniz başarıyla değiştirildi!');
      setPasswordForm({ current: '', newPass: '', confirm: '' });
      setTimeout(() => { setShowPasswordModal(false); setPasswordMsg(''); }, 2000);
    } catch(e) { setPasswordError(e.response?.data?.error || 'Hata oluştu'); }
    setSavingPassword(false);
  };
  const handleLogoutConfirm = () => setShowLogoutConfirm(true);
  const doLogout = () => { logout(); window.location.href = '/giris'; };

  // YENİ FİLTRELEME MANTIĞI
  const mandatoryCourses = myCourses.filter(c => c.is_mandatory && (!searchVal || c.title.toLowerCase().includes(searchVal.toLowerCase())));
  const incompleteMandatory = mandatoryCourses.filter(c => c.has_quiz ? !c.quiz_passed : (!c.completed_at && parseInt(c.completed_videos) < parseInt(c.total_videos)));
  
  const regularCourses = myCourses.filter(c => !c.is_mandatory && (!searchVal || c.title.toLowerCase().includes(searchVal.toLowerCase())));
  
  const completedCourses = regularCourses.filter(c => c.has_quiz ? c.quiz_passed : (!!c.completed_at || (parseInt(c.total_videos) > 0 && parseInt(c.completed_videos) >= parseInt(c.total_videos))));
  const inProgressCourses = regularCourses.filter(c => c.has_quiz ? (!c.quiz_passed && parseInt(c.completed_videos) > 0) : (!c.completed_at && parseInt(c.completed_videos) > 0 && parseInt(c.completed_videos) < parseInt(c.total_videos)));
  const notStartedCourses = regularCourses.filter(c => c.has_quiz ? (!c.quiz_passed && parseInt(c.completed_videos) === 0) : (!c.completed_at && parseInt(c.completed_videos) === 0));

  const tabs = [
    { key: 'my', label: 'Eğitimlerim', badge: myCourses.filter(c => !c.is_mandatory).length, badgeColor: '#E30613' },
    { key: 'mandatory', label: 'Zorunlu Eğitimlerim', badge: incompleteMandatory.length, badgeColor: '#ff3b30' },
    { key: 'catalog', label: 'Tüm Eğitimler', badge: null },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f2f5 0%, #e8eaf6 100%)' }}>
      <style>{`
        .course-card-premium {
          box-shadow: 0 4px 20px rgba(0,0,0,0.07);
          transition: all 0.3s ease;
        }
        .course-card-premium:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px -4px rgba(16,24,40,0.12);
          border-color: #d0d5dd !important;
        }
        .course-thumb-premium {
          transition: transform 0.4s ease;
        }
        .course-card-premium:hover .course-thumb-premium {
          transform: scale(1.08);
        }
      `}</style>
      {isMobile && pullDistance > 0 && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999, display: 'flex', justifyContent: 'center', paddingTop: pullDistance / 2, transition: 'none' }}>
          <div style={{ background: 'white', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.15)', transform: `rotate(${pullDistance * 3}deg)` }}>
            {refreshing ? '⟳' : '↓'}
          </div>
        </div>
      )}
      {refreshing && isMobile && (
        <div style={{ position: 'fixed', top: 8, left: 0, right: 0, zIndex: 999, display: 'flex', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: 20, padding: '6px 16px', fontSize: 12, color: '#6b7280', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ animation: 'spin 1s linear infinite', display: 'inline-block' }}>⟳</span> Yenileniyor...
          </div>
        </div>
      )}
      <Navbar user={user} onLogout={handleLogout} onSearch={setSearchVal} searchVal={searchVal} notifications={notifications} onMenuToggle={() => setSidebarOpen(true)} onPasswordChange={openPasswordModal} onRefresh={() => window.location.reload()} refreshing={refreshing} />

      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(4px)', zIndex: 300 }} />
      )}

      <div style={{ position: 'fixed', top: 0, left: sidebarOpen ? 0 : -300, width: 280, height: '100vh', background: 'white', zIndex: 400, transition: 'left 0.3s cubic-bezier(0.4,0,0.2,1)', boxShadow: sidebarOpen ? '4px 0 32px rgba(0,0,0,0.15)' : 'none', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
        <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #E30613)', padding: '28px 24px 24px', flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 38, height: 38, background: 'rgba(255,255,255,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <BookOpen size={20} color="white" strokeWidth={2} />
              </div>
              <div>
                <div style={{ fontWeight: 800, fontSize: 15, color: 'white' }}>Petlas Eğitim ve Akademi</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>Eğitim Platformu</div>
              </div>
            </div>
            <button onClick={() => setSidebarOpen(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <X size={15} color="white" />
            </button>
          </div>
          <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 16, color: 'white', flexShrink: 0 }}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 13, color: 'white' }}>{user?.name}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>Öğrenci</div>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, padding: '12px 12px' }}>
          {[
            { icon: LayoutDashboard, label: 'Ana Sayfa', path: '/panel' },
            { icon: GraduationCap, label: 'Eğitimlerim', path: '/panel' },
            { icon: Award, label: 'Sertifikalarım', path: '/sertifikalar' },
            { icon: Newspaper, label: 'Eğitim & Faaliyetler', path: '/faaliyetler' },
          ].map(({ icon: Icon, label, path }) => (
            <button key={label} onClick={() => { setSidebarOpen(false); navigate(path); }}
              style={{ width: '100%', padding: '12px 16px', border: 'none', borderRadius: 12, cursor: 'pointer', fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 12, background: 'transparent', color: '#374151', marginBottom: 4, textAlign: 'left' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(227,6,19,0.08)'; e.currentTarget.style.color = '#E30613'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#374151'; }}>
              <Icon size={18} strokeWidth={1.8} />
              {label}
            </button>
          ))}
        </div>
        <div style={{ padding: '12px 12px 24px', borderTop: '1px solid #f0f0f0' }}>
          <button onClick={() => { setSidebarOpen(false); setShowKvkkRead(true); }}
            style={{ width: '100%', padding: '12px 16px', border: 'none', borderRadius: 12, cursor: 'pointer', fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 12, background: 'transparent', color: '#475569', marginBottom: 6, textAlign: 'left' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#0f172a'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#475569'; }}>
            <ShieldCheck size={18} strokeWidth={1.8} color="#0284c7" />
            KVKK Aydınlatma Metni
          </button>
          <button onClick={() => { setSidebarOpen(false); handleLogoutConfirm(); }}
            style={{ width: '100%', padding: '12px 16px', border: 'none', borderRadius: 12, cursor: 'pointer', fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 12, background: 'rgba(255,59,48,0.06)', color: '#ff3b30', textAlign: 'left' }}>
            <LogOut size={18} strokeWidth={1.8} />
            Çıkış Yap
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1300, margin: '0 auto', padding: isMobile ? '16px 14px' : '26px 28px', position: 'relative', zIndex: 1 }}>

        <div style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #E30613 60%, #8b0000 100%)', borderRadius: 20, padding: isMobile ? '20px 20px' : '28px 32px', marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', position: 'relative' }}>
          <div style={{ zIndex: 1 }}>
            <div style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, color: 'white', marginBottom: 6 }}>
              Merhaba, {user?.name?.split(' ')[0]}! 👋
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
              {incompleteMandatory.length > 0
                ? `${incompleteMandatory.length} zorunlu eğitim seni bekliyor.`
                : 'Tüm zorunlu eğitimlerini tamamladın! 🎉'}
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
              {[
                { icon: Trophy, label: 'Tamamlanan', value: myCourses.filter(c => c.has_quiz ? c.quiz_passed : (!!c.completed_at || (parseInt(c.completed_videos) >= parseInt(c.total_videos) && parseInt(c.total_videos) > 0))).length, color: '#34c759' },
                { icon: Clock, label: 'Devam Eden', value: inProgressCourses.length, color: '#f59e0b' },
                { icon: AlertCircle, label: 'Bekleyen', value: incompleteMandatory.length, color: incompleteMandatory.length > 0 ? '#ef4444' : '#fff' },
              ].map(({ icon: Icon, label, value, color }) => (
                <div key={label} style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.1)', padding: '8px 16px', borderRadius: '20px', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Icon size={16} color={color} />
                  <span style={{ color: 'white', fontSize: 13, fontWeight: 600 }}>{value} {label}</span>
                </div>
              ))}
            </div>

          </div>
          {!isMobile && <BookOpen size={88} color="rgba(255,255,255,0.15)" strokeWidth={1} />}
        </div>

        <div style={{ display: 'flex', marginBottom: 18, background: 'rgba(0,0,0,0.05)', borderRadius: 12, padding: 4, overflowX: 'auto', WebkitOverflowScrolling: 'touch', maxWidth: '100%' }}>
          {tabs.map(({ key, label, badge, badgeColor }) => (
            <button key={key} onClick={() => setTab(key)}
              style={{ padding: isMobile ? '7px 10px' : '8px 18px', border: 'none', borderRadius: 9, cursor: 'pointer', fontWeight: 600, fontSize: isMobile ? 11 : 13, background: tab === key ? 'white' : 'transparent', color: tab === key ? (key === 'mandatory' ? '#ff3b30' : '#E30613') : '#6b7280', boxShadow: tab === key ? '0 2px 8px rgba(0,0,0,0.1)' : 'none', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
              {label}
              {badge > 0 && <span style={{ background: tab === key ? badgeColor : '#9ca3af', color: 'white', borderRadius: 20, padding: '1px 5px', fontSize: 9, fontWeight: 700 }}>{badge}</span>}
            </button>
          ))}
        </div>

        {tab === 'mandatory' && (
          <div>
            {incompleteMandatory.length === 0 ? (
              <div style={{ background: 'rgba(52,199,89,0.1)', border: '1px solid rgba(52,199,89,0.2)', borderRadius: 16, padding: 32, textAlign: 'center' }}>
                <CheckCircle size={40} color="#34c759" style={{ margin: '0 auto 12px' }} />
                <div style={{ fontWeight: 700, fontSize: 16, color: '#34c759' }}>Tüm zorunlu eğitimler tamamlandı!</div>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 14 }}>
                {incompleteMandatory.map(c => <CourseCard key={c.id} course={c} onClick={() => navigate('/egitim/' + c.id)} />)}
              </div>
            )}
          </div>
        )}

        {tab === 'my' && (
          <div>
            {mandatoryCourses.length > 0 && (
              <div style={{ marginBottom: 26 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ background: '#ff3b30', color: 'white', borderRadius: 6, padding: '2px 8px', fontSize: 11 }}>ZORUNLU</span> Zorunlu Eğitimlerim</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
                  {mandatoryCourses.map(c => <CourseCard key={c.id} course={c} onClick={() => navigate('/egitim/' + c.id)} />)}
                </div>
              </div>
            )}
            {notStartedCourses.length > 0 && (
              <div style={{ marginBottom: 26 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 6 }}><BookOpen size={16} color="#8b0000" /> Başlanmamış Eğitimler</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
                  {notStartedCourses.map(c => <CourseCard key={c.id} course={c} onClick={() => navigate('/egitim/' + c.id)} />)}
                </div>
              </div>
            )}
            {inProgressCourses.length > 0 && (
              <div style={{ marginBottom: 26 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 6 }}><Clock size={16} color="#E30613" /> Devam Eden Eğitimler</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
                  {inProgressCourses.map(c => <CourseCard key={c.id} course={c} onClick={() => navigate('/egitim/' + c.id)} />)}
                </div>
              </div>
            )}
            {completedCourses.length > 0 && (
              <div style={{ marginBottom: 26 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 6 }}><CheckCircle size={16} color="#34c759" /> Tamamlanan Eğitimler</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
                  {completedCourses.map(c => <CourseCard key={c.id} course={c} onClick={() => navigate('/egitim/' + c.id)} />)}
                </div>
              </div>
            )}
            {regularCourses.length === 0 && (
              <div style={{ background: 'rgba(255,255,255,0.8)', borderRadius: 16, padding: 40, textAlign: 'center', color: '#9ca3af' }}>
                <BookOpen size={40} strokeWidth={1} style={{ margin: '0 auto 12px' }} />
                <div style={{ fontWeight: 600 }}>Henüz atanmış eğitim yok</div>
              </div>
            )}
          </div>
        )}

        {tab === 'catalog' && (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(230px, 1fr))', gap: 14 }}>
              {filteredCatalog.map(c => (
                <div key={c.id} style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.07)', border: '1px solid rgba(255,255,255,0.9)' }}>
                  <div style={{ height: 110, background: c.thumbnail ? 'transparent' : 'linear-gradient(135deg, #1a1a2e, #E30613)', overflow: 'hidden' }}>
                    {c.thumbnail
                      ? <img src={'/uploads/thumbnails/' + c.thumbnail + '?v=2'} alt={c.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><BookOpen size={32} color="rgba(255,255,255,0.4)" strokeWidth={1} /></div>}
                  </div>
                  <div style={{ padding: '12px 14px' }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a2e', marginBottom: 10, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{c.title}</div>
                    <button onClick={async () => {
                      if (c.enrolled) { navigate('/egitim/' + c.id); return; }
                      await api.post('/courses/' + c.id + '/enroll');
                      const r = await api.get('/users/me/courses');
                      setMyCourses(r.data);
                      setCatalog(prev => prev.map(x => x.id === c.id ? {...x, enrolled: true} : x));
                      setFilteredCatalog(prev => prev.map(x => x.id === c.id ? {...x, enrolled: true} : x));
                      setTab('my');
                    }}
                      style={{ width: '100%', padding: '9px', background: c.enrolled ? 'rgba(227,6,19,0.08)' : 'linear-gradient(135deg, #E30613, #8b0000)', color: c.enrolled ? '#E30613' : 'white', border: c.enrolled ? '1.5px solid rgba(227,6,19,0.2)' : 'none', borderRadius: 9, cursor: 'pointer', fontWeight: 700, fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
                      {c.enrolled ? <><Play size={11} fill="#E30613" /> Devam Et</> : <><Plus size={11} /> Kayıt Ol</>}
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {filteredCatalog.length === 0 && (
              <div style={{ background: 'rgba(255,255,255,0.8)', borderRadius: 16, padding: 40, textAlign: 'center', color: '#9ca3af' }}>Eğitim bulunamadı</div>
            )}
          </div>
        )}
      </div>
      {showPasswordModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 20, padding: '32px 28px', maxWidth: 380, width: '100%', boxShadow: '0 32px 80px rgba(0,0,0,0.2)' }}>
            <div style={{ fontWeight: 800, fontSize: 18, color: '#1a1a2e', marginBottom: 16 }}>👤 Profil</div>
            <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: 'rgba(0,0,0,0.05)', borderRadius: 10, padding: 3 }}>
              {[['profile','Profil Bilgileri'],['password','Şifre Değiştir']].map(([key, label]) => (
                <button key={key} onClick={() => setProfileTab(key)}
                  style={{ flex: 1, padding: '7px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 12, background: profileTab === key ? 'white' : 'transparent', color: profileTab === key ? '#E30613' : '#6b7280', boxShadow: profileTab === key ? '0 2px 6px rgba(0,0,0,0.1)' : 'none' }}>
                  {label}
                </button>
              ))}
            </div>

            {profileTab === 'profile' ? (
              <div>
                <div style={{
                  background: 'rgba(227,6,19,0.05)',
                  border: '1px solid rgba(227,6,19,0.12)',
                  borderRadius: 10,
                  padding: '10px 12px',
                  marginBottom: 16,
                  color: '#6b7280',
                  fontSize: 12,
                  lineHeight: 1.5
                }}>
                  ℹ️ E-posta adresinizi ve telefon numaranızı bu bölümden güncelleyebilirsiniz.
                </div>

                {profileMsg && <div style={{ background: 'rgba(52,199,89,0.1)', border: '1px solid rgba(52,199,89,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, color: '#34c759', fontWeight: 600, fontSize: 13 }}>✅ {profileMsg}</div>}
                {profileError && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, color: '#ef4444', fontSize: 13 }}>⚠️ {profileError}</div>}
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 13, color: '#555' }}>E-posta</label>
                  <input type="email" value={profileForm.email} onChange={e => setProfileForm({...profileForm, email: e.target.value})}
                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 13, color: '#555' }}>Telefon</label>
                  <input type="tel" value={profileForm.phone} onChange={e => setProfileForm({...profileForm, phone: e.target.value})}
                    placeholder="05XX XXX XX XX"
                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setShowPasswordModal(false)}
                    style={{ flex: 1, padding: '12px', border: '1.5px solid #e5e7eb', borderRadius: 50, background: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14, color: '#6b7280' }}>İptal</button>
                  <button onClick={saveProfile} disabled={savingProfile}
                    style={{ flex: 1, padding: '12px', border: 'none', borderRadius: 50, background: '#E30613', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
                    {savingProfile ? 'Kaydediliyor...' : 'Kaydet'}
                  </button>
                </div>
              </div>
            ) : (
              <div>
            {passwordMsg && <div style={{ background: 'rgba(52,199,89,0.1)', border: '1px solid rgba(52,199,89,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, color: '#34c759', fontWeight: 600, fontSize: 13 }}>✅ {passwordMsg}</div>}
            {passwordError && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, color: '#ef4444', fontSize: 13 }}>⚠️ {passwordError}</div>}

            {[['current','Mevcut Şifre'],['newPass','Yeni Şifre'],['confirm','Yeni Şifre (Tekrar)']].map(([key, label]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, fontSize: 13, color: '#555' }}>{label}</label>
                <input type="password" value={passwordForm[key]} onChange={e => setPasswordForm({...passwordForm, [key]: e.target.value})}
                  autoComplete="new-password"
                  style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e5e7eb', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
              </div>
            ))}

            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button onClick={() => { setShowPasswordModal(false); setPasswordForm({ current: '', newPass: '', confirm: '' }); setPasswordError(''); setPasswordMsg(''); }}
                style={{ flex: 1, padding: '12px', border: '1.5px solid #e5e7eb', borderRadius: 50, background: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14, color: '#6b7280' }}>
                İptal
              </button>
              <button onClick={changePassword} disabled={savingPassword}
                style={{ flex: 1, padding: '12px', border: 'none', borderRadius: 50, background: '#E30613', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: 14, boxShadow: '0 4px 14px rgba(227,6,19,0.3)' }}>
                {savingPassword ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
            </div>
            )}
          </div>
        </div>
      )}

      {showLogoutConfirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 20, padding: '32px 28px', maxWidth: 360, width: '100%', boxShadow: '0 32px 80px rgba(0,0,0,0.2)', textAlign: 'center' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(227,6,19,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <LogOut size={24} color="#E30613" />
            </div>
            <div style={{ fontWeight: 800, fontSize: 18, color: '#1a1a2e', marginBottom: 8 }}>Çıkış Yap</div>
            <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 28, lineHeight: 1.6 }}>Petlas Eğitim ve Akademi platformundan çıkmak istediğinize emin misiniz?</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowLogoutConfirm(false)}
                style={{ flex: 1, padding: '12px', border: '1.5px solid #e5e7eb', borderRadius: 50, background: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14, color: '#6b7280' }}>
                İptal
              </button>
              <button onClick={doLogout}
                style={{ flex: 1, padding: '12px', border: 'none', borderRadius: 50, background: '#E30613', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: 14, boxShadow: '0 4px 14px rgba(227,6,19,0.3)' }}>
                Çıkış Yap
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ maxWidth: 1300, margin: '24px auto 0', padding: '16px 28px', borderTop: '1px solid rgba(0,0,0,0.06)', textAlign: 'center' }}>
        <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600 }}>Eğitim ve Akademi Şefliği</div>
        <div style={{ fontSize: 10, color: '#d1d5db', marginTop: 2 }}>© 2026 Petlas A.Ş. — Tüm hakları saklıdır.</div>
      </div>
    
      {/* İlk Giriş Zorunlu KVKK Karşılama */}
      <KvkkModal
        isOpen={showKvkkWelcome}
        isMandatory={true}
        onClose={handleKvkkConfirm}
        onAcknowledge={handleKvkkConfirm}
      />

      {/* Menüden Serbest İnceleme Modalı */}
      <KvkkModal
        isOpen={showKvkkRead}
        isMandatory={false}
        onClose={() => setShowKvkkRead(false)}
        onAcknowledge={() => setShowKvkkRead(false)}
      />
    </div>
  );
};